export class CareerEducationModel {
    constructor(public code: string, public name: string){}
}